import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useAccessPermissionStore } from "@/stores/access-permission";
import {
  AccessPermissionDataPayload,
  AccessPermissionDataResponse,
} from "@/types/interface/access-permission";
import { mapOptionMultiselect } from "@/utils/helper";
import { useModuleStore } from "@/stores/master/module";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAccessPermission',
  setup(__props) {

const idAccessPermission = ref<string>("");
const listModule = ref([]);
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const accessPermissionStore = useAccessPermissionStore();
const moduleStore = useModuleStore();
const detailAccessPermission = ref<AccessPermissionDataResponse>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod
      .string()
      .nonempty({ message: "Access Permission Name is required" }),
    module: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: module } = useField<string>("module");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadAccessPermission: AccessPermissionDataPayload = {
    name: name.value,
    module_id: module.value?.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await accessPermissionStore.dispatchUpdate(
      idAccessPermission.value,
      payloadAccessPermission
    );
  } else {
    responseApi.value = await accessPermissionStore.dispatchCreate(
      payloadAccessPermission
    );
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Access Permission Successfully Updated"
          : "Access Permission Successfully Added"
      );
      router.push("/master/access-permission");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadListModule = async () => {
  const { success } = await moduleStore.dispatchGetAll(0, 99, "");
  listModule.value = mapOptionMultiselect(
    moduleStore.modules.items,
    "id",
    "name"
  );
};

const loadDetailAccessPermission = async () => {
  const { success, message } = await accessPermissionStore.dispatchDetail(
    idAccessPermission.value
  );
  if (success) {
    detailAccessPermission.value = await accessPermissionStore.category?.data;
    name.value = detailAccessPermission.value?.name;
    module.value = mapOptionMultiselect(detailAccessPermission?.value?.module);
  }
};

onMounted(() => {
  loadListModule();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idAccessPermission.value = router.currentRoute.value.params.id.toString();
    loadDetailAccessPermission();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Access Permission"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/access-permission"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Access Permission ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("label", {
                        for: "category_code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Module "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(module),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(module) ? (module).value = $event : null)),
                          options: listModule.value,
                          placeholder: "Choose Module"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).module), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Access Permission Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Access Permission Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})